// removed by extract-text-webpack-plugin
module.exports = {"component":"DYChQieD8kUROZYwwsl5U"};